// src/actions.js

export const setUserLocationData = (data) => {
    return {
      type: 'SET_USER_LOCATION_DATA',
      payload: data
    };
  };
